module.exports = __webpack_public_path__ + "img/7_161.96f2ed64.png";